export enum Type {
  NEGATIVE = 'negative',
  NEUTRAL = 'neutral',
  OTHER = 'other',
  POSITIVE = 'positive',
}
